<template>
<span :class="'badge badge-pill '+application.status" title="Application status">{{application.status}}</span>
</template> 

<script>
export default {
  props: ['application_id'],

  data() {
    return {
      application: [],
    };
  },

  mounted() {
    
  },

  created() {
    this.getApplicationInfo();
  },

  methods: {
    
    getApplicationInfo() {
      axios.get("/applications/getinfo/"+this.application_id)
           .then((response) => {
        this.application = response.data;
      });
    },

  },
};
</script>

<style scoped>
td:hover {cursor: pointer;}
.application_image { width: 100%; border-radius: 0.25rem; }
</style>